<template>
    <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
            <div class="account-box">
                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                    <li v-for="error in errors.all()">{{ error }}</li>
                </ul>
                <div class="account-box-content">
                    <form @submit.prevent="redirectToBank" class="form-account">
                        <div class="form-account-title">مبلغ مورد نظر برای افزایش موجودی ( تومان ) </div>
                        <div class="form-account-row">
                            <label class="input-label"><i class="now-ui-icons shopping_credit-card"></i></label>
                            <input class="input-field" type="text" v-model="totalAmount" v-validate="{required:true,numeric:true,min:3,max:10}" data-vv-as="مبلغ" placeholder="مبلغ را به تومان وارد کنید">
                        </div>
                        <div class="form-account-agree">
                            <label class="checkbox-form checkbox-primary">
                                <input type="checkbox" v-model="checked">
                                <span class="checkbox-check"></span>
                            </label>
                            <label for="agree">
                                <router-link target="_blank" to="/rules" class="btn-link-border">قوانین و شرایط</router-link> را می پذیرم.
                            </label>
                        </div> 
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="row main-dargah">
                                <div v-if="baseInfo != null && baseInfo.IsActiveMellatBank" class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="dargah">
                                        <img src="/assets/img/mellat.png" />
                                        <div> <input id="mellatBank" name="gatway" type="radio" value="3" v-model="gatwayType" /><label class="lbl-dargah" for="mellatBank">بانک‌ملت</label></div>
                                    </div>
                                </div>
                                <div v-if="baseInfo != null && baseInfo.IsActiveSamanKish" class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="dargah">
                                        <img src="/assets/img/kish.png" />
                                        <div> <input id="samankish" name="gatway" type="radio" value="1" v-model="gatwayType" /><label class="lbl-dargah" for="samankish">سامان‌کیش</label></div>
                                    </div>
                                </div>
                                <div v-if="baseInfo != null && baseInfo.IsActiveZarinPal" class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="dargah">
                                        <img src="/assets/img/ZarinPal.jpg" />
                                        <div><input id="zarinpal" name="gatway" type="radio" value="2" v-model="gatwayType" /><label class="lbl-dargah" for="zarinpal">زرین‌پال</label></div>
                                    </div>
                                </div>
                                <div v-if="baseInfo != null && baseInfo.IsActiveIranKish" class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="dargah">
                                        <img src="/assets/img/kish.png" />
                                        <div><input id="irankish" name="gatway" type="radio" value="5" v-model="gatwayType" /><label class="lbl-dargah" for="irankish">ایران کیش</label></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-account-row form-account-submit">
                            <div class="parent">
                                <button :class="{'disadledbtn' :!checked ,'dk-btn dk-btn-info':true}" :disabled="!checked" type="submit">
                                    پرداخت آنلاین
                                    <i class="now-ui-icons arrows-1_share-66"></i>
                                </button>
                                <div :class="{'main-loader':!showloaderbtn}">
                                    <div class="div-loader">
                                        <img src="/assets/img/loader/loader.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                showloaderbtn:false,
                checked: true,
                totalAmount: '',
                gatwayType: 0,
            }
        },
        beforMount: function () {
            this.isShowSppiner = true;
            httpPromise(this, '/v1/Identity/CustomersFinince/GetBalance', 'get', '',
                response => {
                    toastr.remove();
                    this.balance = response.data.Value.Balance;
                    this.isShowSppiner = false;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                    this.isShowSppiner = false;
                });
        },
        methods: {
            //==============================================================
            redirectToBank() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        if (parseInt(this.gatwayType) == 0) {
                            toastr.remove();
                            toastr.error('درگاه بانکی را انتخاب کنید');
                            return;
                        }
                        this.isShowSppiner = true;
                        this.showloaderbtn = true;
                        var url = '';
                        if (parseInt(this.gatwayType) == 1) {
                            url = '/v1/Orders/SamanKishCreditPayment/GetBankPaymentUrl';
                        }
                        if (parseInt(this.gatwayType) == 2) {
                            url = '/v1/Orders/ZarinPalCreditPayment/GetBankPaymentUrl/';
                        }
                        if (parseInt(this.gatwayType) == 3) {
                            url = '/v1/Orders/MellatBankCreditPayment/GetBankPaymentUrl/';
                        }
                        if (parseInt(this.gatwayType) == 5) {
                            url = '/v1/Orders/IranKishCreditPayment/GetBankPaymentUrl/';
                        }
                        httpPromise(this, url, 'get', { TotalAmount: this.totalAmount },
                            response => {
                                var paymentUrl = response.data.Value.PaymentUrl; 
                                window.location.href = paymentUrl;
                                this.showloaderbtn = false;
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                                this.showloaderbtn = false;
                            });
                    }
                });
            },
            //==============================================================
        }, 
        computed: { 
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
    }
</script>

<style scoped>
    .account-box-content {
        padding: 0 14px;
    }
    .main-dargah {
        margin-bottom: 20px;
        margin-top: 20px;
    }
    .lbl-dargah {
        padding-right: 7px;
    }

    .dargah img {
        width: 90px;
        display:block;
        margin-bottom:5px;
    }
    .dargah{
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    }
</style>